/* eslint-disable jsx-a11y/heading-has-content */
import * as React from "react";

import { cn } from "@/lib/utils";

const defaultStyles = {
  borderClass: "dark:border-gray-800",
  bgClass: "dark:bg-[#12171C]"
};

// Estilos para la variante level-two
const levelTwoStyles = {
  borderClass: "dark:border-gray-700",
  bgClass: "dark:bg-gray-800"
};

const infoStyles = {
  borderClass: "dark:border-gray-800",
  bgClass: "bg-[#F7F6F9] dark:bg-[#0f1c29]"
};

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "level-two" | "info" | "no-shadow";
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = "default", ...props }, ref) => {
    let styles;
    let shadowClass = "shadow";
    switch (variant) {
      case "level-two":
        styles = levelTwoStyles;
        break;
      case "info":
        styles = infoStyles;
        break;
      case "no-shadow":
        styles = defaultStyles;
        shadowClass = ""; //  Sin sombra
        break;
      case "default":
      default:
        styles = defaultStyles;
        break;
    }

    return (
      <div
        ref={ref}
        className={cn(
          "rounded-xl border bg-card text-card-foreground",
          shadowClass,
          styles.borderClass,
          styles.bgClass,
          className
        )}
        {...props}
      />
    );
  }
);
Card.displayName = "Card";

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6 pb-1", className)}
    {...props}
  />
));
CardHeader.displayName = "CardHeader";

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h4
    ref={ref}
    className={cn(
      "text-base font-semibold leading-none tracking-tight",
      className
    )}
    {...props}
  >
    {props.children}
  </h4>
));
CardTitle.displayName = "CardTitle";

const CardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
));
CardDescription.displayName = "CardDescription";

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
));
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props}
  />
));
CardFooter.displayName = "CardFooter";

export {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
};
